import { queryOptions } from '@tanstack/react-query'
import { notFound } from '@tanstack/react-router'
import { createServerFn } from '@tanstack/react-start'
import axios from 'redaxios'

export type PostType = {
  id: string
  title: string
  body: string
}

export const fetchPosts = createServerFn({ method: 'GET' }).handler(
  async () => {
    console.info('Fetching posts...')
    return axios
      .get<Array<PostType>>('https://jsonplaceholder.typicode.com/posts')
      .then((r) => r.data.slice(0, 10))
  },
)

export const postsQueryOptions = () =>
  queryOptions({
    queryKey: ['posts'],
    queryFn: () => fetchPosts(),
  })

// Loosen the typing here because these demo server functions are only used
// in example routes and the `createServerFn` typing has changed between
// TanStack Start versions.
export const fetchPost: any = createServerFn({ method: 'GET' }).handler(
  async ({ data }: any) => {
    console.info(`Fetching post with id ${data}...`)
    const post = await axios
      .get<PostType>(`https://jsonplaceholder.typicode.com/posts/${data}`)
      .then((r) => r.data)
      .catch((err) => {
        console.error(err)
        if ((err as any).status === 404) {
          throw notFound()
        }
        throw err
      })

    return post
  },
)

export const postQueryOptions = (postId: string) =>
  queryOptions({
    queryKey: ['post', postId],
    // Cast to any to avoid strict typing issues with `createServerFn`
    queryFn: () => (fetchPost as any)({ data: postId }),
  })
